exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#slogan{padding-top:110px;font-size:32px;font-weight:100;line-height:1}.wallpaper{max-width:100%;width:100%;border:none;margin:0;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-620d9d61","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MainContent.vue
// module id = 57
// module chunks = 0